import React from 'react'
import Logo from "../../assets/images/Main-logo.png"
import Icon1 from "../../assets/images/icon-53.png"
import Icon2 from "../../assets/images/icon-54.png"
import Icon3 from "../../assets/images/icon-55.png"
import { Link } from 'react-router-dom'
import { config } from '../pages/config'

import payment1 from "../../assets/images/payment/VISA.png"
import payment2 from "../../assets/images/payment/MASTERCARD.png"
import payment3 from "../../assets/images/payment/MAESTRO.png"
import payment4 from "../../assets/images/payment/DINERSCLUB.jpg"
import payment5 from "../../assets/images/payment/DISCOVER.png"
import payment6 from "../../assets/images/payment/APPLEPAY.png"
import payment7 from "../../assets/images/payment/GOOGLEPAY.png"

const Footer = () => {
    const year = new Date().getFullYear()
    return (
        <div>
            <footer className="main-footer">
                <div className="bg-layer"></div>
                <div className="footer-top">
                    <div className="auto-container">
                        <div className="row clearfix justify-content-between">
                            <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
                                <div className="footer-widget logo-widget">
                                    <figure className="footer-logo p-3 bg-white">
                                        <Link to={`${config.appUrl}`}>
                                            <img src={Logo} alt="" /></Link>
                                    </figure>
                                    <p className='text-white mb-3'>At Precision Driving School, we take pride in offering comprehensive and specialized training for those seeking to elevate their driving skills to the next level. </p>
                                    <h4>We Accept</h4>
                                    <div>
                                        <img src={payment1} alt='paymentOptionImage' className='payment_logo' />
                                        <img src={payment2} alt='paymentOptionImage' className='payment_logo' />
                                        <img src={payment3} alt='paymentOptionImage' className='payment_logo' />
                                        <img src={payment4} alt='paymentOptionImage' className='payment_logo' />
                                        <img src={payment5} alt='paymentOptionImage' className='payment_logo' />
                                        <img src={payment6} alt='paymentOptionImage' className='payment_logo' />
                                        <img src={payment7} alt='paymentOptionImage' className='payment_logo' />
                                    </div>
                                    <p className='mt-3'>Security provided by NatWest</p>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-12 footer-column">
                                <div className='d-flex justify-content-between justify-content-md-evenly'>
                                    <div className="footer-widget links-widget">
                                        <div className="widget-title">
                                            <h4>Quick Links</h4>
                                        </div>
                                        <div className="widget-content">
                                            <ul className="links-list clearfix">
                                                <li><Link to={`${config.appUrl}courses`}>Our Courses</Link></li>
                                                <li><Link to={`${config.appUrl}instructors`}>Our Instructors</Link></li>
                                                <li><Link to={`${config.appUrl}faqs`}>FAQs</Link></li>
                                                <li><Link to={`${config.appUrl}contact-us`}>Contact Us</Link></li>
                                                <li><a href={`${config.ClientUrl}`} target='_blank'> Register As Instructor</a></li>
                                                {/* <li><a href="#">Start Franchise <span className="badge badge-primary pe-2 text-white " style={{ backgroundColor: "#c91a1a", borderRadius: "2px" }}>New !</span></a></li> */}
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="footer-widget links-widget ps-md-0 ps-4">
                                        <div className="widget-title">
                                            <h4>Important Link</h4>
                                        </div>
                                        <div className="widget-content">
                                            <ul className="links-list clearfix">
                                                <li><Link to={`${config.appUrl}how-to-become-instructor`}>Become an Instructor</Link></li>
                                                {/* <li><Link to={`${config.appUrl}our-locations`}>Our Locations</Link></li> */}
                                                <li><Link to={`${config.appUrl}about-practical-test`}>Book Practical Test</Link></li>
                                                <li><Link to={`${config.appUrl}about-theory-test`}>Book Theory Test</Link></li>
                                                <li><a href={`https://www.gov.uk/government/organisations/driver-and-vehicle-standards-agency`} target='_blank'>DVSA Website</a></li>
                                                <li><Link to={`${config.appUrl}blogs`}>Blog & News</Link></li>
                                                <li><Link to={`${config.appUrl}refresher-driver-lessons`}>Refresher driver lessons</Link></li>
                                                <li><a href={`https://www.safedrivingforlife.info/advice/car-driving/how-drive-car/`} target='_blank'>How to drive a car?</a></li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                                <div className="footer-widget gallery-widget">
                                    <div className="widget-title">
                                        <h4>Contact Details</h4>
                                    </div>
                                    <div className="widget-content row align-items-center">
                                        <div className="single-item col-md-6 mb-4 d-flex d-xl-block">
                                            <div className="icon-box">
                                                <img src={Icon1} alt="" width='35' /></div>
                                            <div className='ps-4 ps-xl-0'>
                                                <h5 className='text-white mb-2 mt-0 mt-xl-2'>We are Here</h5>
                                                <p className='' style={{ fontSize: "14px" }}>4 Rivers Street, Leicester, <br className='d-none d-xl-none' />England, LE3 5RX</p>
                                            </div>
                                        </div>
                                        <div className="single-item col-md-6 mb-4 d-flex d-xl-block">
                                            <div className="icon-box">
                                                <img src={Icon2} alt="" width='35' /></div>
                                            <div className='ps-4 ps-xl-0'>
                                                <h5 className='text-white mb-2 mt-0 mt-xl-2'>Quick Contact</h5>
                                                <div>
                                                    <a href='tel:0116 210 2688' style={{ fontSize: "14px", color: '#74757b' }}>
                                                        0116 210 2688
                                                    </a>
                                                </div>
                                                <div>
                                                    <a href='tel:+44 7380 851496' style={{ fontSize: "14px", color: '#74757b' }}>
                                                        +44 7380 851496
                                                    </a>
                                                </div>
                                                <div>
                                                    <a href='mailto:info@precisiondriving.uk'
                                                        style={{ fontSize: "14px", color: '#74757b' }}>info@precisiondriving.uk</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="single-item col-md-6 d-flex d-xl-block">
                                            <div className="icon-box">
                                                <img src={Icon3} alt="" width='35' /></div>
                                            <div className='ps-4 ps-xl-0'>
                                                <h5 className='text-white mb-2 mt-0 mt-xl-2'>Training Time</h5>
                                                <p style={{ fontSize: "14px" }}>
                                                    <span className='text-white'>Mon-Fri:</span> <br /> 9:00 AM – 6:00 PM <br />
                                                    <span className='text-white'>Saturday:</span> <br /> 10:00 AM – 2:00 PM <br />
                                                    <span className='text-white'>Sunday:</span> <br /> Closed
                                                </p>
                                            </div>
                                        </div>
                                        <div className='col-md-6 single-item mt-4'>
                                            <ul className="social-links mt-md-0 mt-4 clearfix d-flex gap-2">
                                                <li><a target='_blank' href="https://www.facebook.com/profile.php?id=61550973842314"><i className="bi bi-facebook"></i></a></li>
                                                {/* <li><a href="#" target='_blank'><i className="bi bi-twitter-x"></i></a></li>
                                                <li><a href="#" target='_blank'><i className="bi bi-linkedin"></i></a></li>
                                                <li><a href="#" target='_blank'><i className="bi bi-instagram"></i></a></li> */}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom d-md-flex justify-content-between auto-container">
                    <div className="auto-containers py-md-0 py-4">
                        <ul className="list gap-3">
                            <li><Link to={`${config.appUrl}privacy-policy`}>Privacy Policy</Link></li>
                            <li><Link to={`${config.appUrl}terms-and-conditions`}>Terms &amp; Conditions</Link></li>
                            <li><Link to={`${config.appUrl}refund-and-Delivery`}>Refund & Delivery</Link></li>
                            {/* <li><a href="#">Site Map</a></li> */}
                        </ul>
                    </div>
                    <div className='px-md-0  px-4'>
                        <p>Copyrights <span>© {year} <span >Precision Driving</span>.</span> Design By <span>
                            <a href="https://www.zithas.co.uk" className='text-green' target="blank"> Zithas Technologies</a>
                        </span></p>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Footer
